import { TrustBoxProps } from "../../../features/integrations/components/TrustBox"

export const toTrustBoxProps = (content: any): TrustBoxProps => {
  return {
    body: content?.data?.body,
    id: content?.data?.id,
  }
}
